module.exports = __webpack_public_path__ + "img/ZB_case_study_page.1b86a021.webp";